import {createAction, createReducer} from 'redux-act';

import {QuickSearchType, QuickSearchSetterType} from './quickSerachType';

export const initialState: QuickSearchType = {
    isVisible: false,
    withSuggestions: true,
    placeholder: 'Type what you looking for',
    searchingCategory: '',
};

/**
 * Sets visibility flag of the quick search panel
 * @param {boolean} - visibility flag: pass "true" to show the panel or "false" to hide it
 */
export const setQuickSearchVisibility = createAction<boolean>('QUICK_SEARCH_SET_VISIBILITY');

/**
 * Sets configuration of the quick search panel rendering
 * @param {QuickSearchSetterType} - rendering options:
 * "withSuggestion" - show block with the most popular search queries,
 * "placeholder" - placeholder of the search input,
 * "searchingCategory" - name of the category which be used for focused search in this category only
 */
export const setQuickSearchParams = createAction<QuickSearchSetterType, QuickSearchSetterType>(
    'QUICK_SEARCH_SET_PARAMS',
    ({withSuggestions = false, placeholder = '', searchingCategory = ''}) => ({
        withSuggestions,
        placeholder,
        searchingCategory,
    }),
);

export const quickSearch = createReducer<QuickSearchType>({}, initialState)
    .on(setQuickSearchParams, (state, payload) => ({...state, ...payload}))
    .on(setQuickSearchVisibility, (state, payload) => ({...state, isVisible: payload}));
